<script setup lang="tsx">
import { onMounted, onUnmounted, ref } from "vue";
import { getCSSVar, injectStyle } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    fromColor?: string;
    toColor?: string;
  }>(),
  {
    fromColor: getCSSVar("--xg-blue"),
    toColor: getCSSVar("--xg-red")
  }
);

const dotStyle = { backgroundColor: props.fromColor, width: "20%" };

const loading3 = ref();

onMounted(() => {
  /// for ce
  injectStyle(
    `
  @keyframes snake {
    0% {
      opacity: 0.3;
      transform: translateY(0px);
      box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    }
    50% {
      opacity: 1;
      transform: translateY(-10px);
      background-color: ${props.toColor};
      box-shadow: 0px 20px 3px rgba(0, 0, 0, 0.05);
    }
    100% {
      opacity: 0.3;
      transform: translateY(0px);
      box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    }
  }
`,
    loading3.value
  );
});

onUnmounted(() => {});
</script>

<template>
  <div
    class="loading-3"
    ref="loading3"
  >
    <div
      class="dot"
      :style="{ ...dotStyle, left: '0' }"
    ></div>
    <div
      class="dot"
      :style="{ ...dotStyle, left: '20%' }"
    ></div>
    <div
      class="dot"
      :style="{ ...dotStyle, left: '40%' }"
    ></div>
    <div
      class="dot"
      :style="{ ...dotStyle, left: '60%' }"
    ></div>
    <div
      class="dot"
      :style="{ ...dotStyle, left: '80%' }"
    ></div>
  </div>
</template>

<style scoped>
.loading-3 {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  text-align: center;
  /* animation: rotate 2s infinite linear; */
}

.dot {
  display: inline-block;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  aspect-ratio: 1 / 1;
  opacity: 0.5;
  border-radius: 100%;
  animation: snake 1s infinite ease-in-out;
}

.loading-3 div:nth-child(1) {
  animation-delay: 0s;
}
.loading-3 div:nth-child(2) {
  animation-delay: 0.2s;
}
.loading-3 div:nth-child(3) {
  animation-delay: 0.4s;
}
.loading-3 div:nth-child(4) {
  animation-delay: 0.6s;
}
.loading-3 div:nth-child(5) {
  animation-delay: 0.8s;
}
</style>
